import { useParams } from "react-router-dom";
import { themeVars } from "../theme";
import { thankyouTemplateFor } from "./thankyou-index";

/** Static preview harness for the 17 thank-you templates — /thankyou-preview/:id. */
const PRESETS = {
  1: ["#1daa61", "#ffffff", "#0d1117"], 2: ["#f59e0b", "#1e1b4b", "#0f0d1a"],
  3: ["#00bba7", "#009e8d", "#1e2530"], 4: ["#c9a84c", "#17150e", "#17150e"],
  5: ["#b5f23d", "#0a0a0a", "#0a0a0a"], 6: ["#6d5efc", "#ffffff", "#eef1f8"],
  7: ["#f43f5e", "#ffffff", "#0a0a10"], 8: ["#6366f1", "#ffffff", "#15162f"],
  9: ["#d4a24e", "#1a1208", "#0c0b10"], 10: ["#c2683f", "#ffffff", "#2a2018"],
  11: ["#4f46e5", "#ffffff", "#0f1424"], 12: ["#8b5cf6", "#ffffff", "#140a1f"],
  13: ["#e11d48", "#ffffff", "#0a0a0a"], 14: ["#22d3ee", "#06141f", "#060f1d"],
  15: ["#ff6b3d", "#ffffff", "#2a1a14"], 16: ["#4f7cff", "#ffffff", "#070b1a"],
  17: ["#2ee6a6", "#04110b", "#05080a"],
};

export default function ThankYouPreview() {
  const { id } = useParams();
  const n = Number(id) || 1;
  const [primary, btnText, footerBg] = PRESETS[n] || PRESETS[1];
  const data = {
    template_id: n, primary, btnText, footerBg,
    course_name: "Full-Stack Web Development", community_name: "My Academy",
    sub_headline: "You're all set — your login details are below.", guarantee_status: false,
    order_id: "CO-9F2K7QX4TZ8M", amount: 199, currency: "USD",
    email: "jane@example.com", password: "KTG3g7t595", is_new: true,
    login_url: "#", logo: null,
  };
  const Template = thankyouTemplateFor(n);
  const vars = themeVars({ primary, btnText, footerBg });
  return (
    <div style={vars}>
      <Template data={data} />
    </div>
  );
}
